<div mdbModal #seleccionarProveedor="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" style="max-width: 1000px;" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Seleccionar proveedor
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <form [formGroup]='formData' (ngSubmit)="queryType === 'ONLY_RUT' ? buscar(true) : buscarPorDeuda(true)" novalidate>
                <div class="modal-body">

                    <div class="row">
                        <div class="col">
                            <div class="md-form">
                                <input value="" type="text" id="nombreProduct" class="form-control"
                                    placeholder="Nombre del proveedor" #nombreProduct formControlName="nombre" />
                                <label for="nombreProduct">Nombre del proveedor</label>
                            </div>
                        </div>
                        <div class="col">
                            <div class="md-form">
                                <input value="" type="text" id="nombreProduct" class="form-control"
                                    placeholder="RUT del proveedor" #nombreProduct formControlName="rut" formatRut />
                                <label for="nombreProduct">RUT del proveedor</label>
                            </div>
                        </div>
                        <div class="col" style="width: 50px;">
                            <button mdbBtn type="submit" class="btn-cuadrado" color="secondary" mdbWavesEffect>
                                <mdb-icon fas icon="search"></mdb-icon>
                            </button>
                        </div>
                    </div>

                    <div class="row" *ngIf="busquedaIniciada && data.length === 0">
                        <div class="col">
                            <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                                No existen registros para el filtro seleccionado</a>
                        </div>
                    </div>

                    <table class="table table-striped table-hover table-sm align-middle"
                        *ngIf="busquedaIniciada && data.length > 0">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col" class="text-center">RUT</th>
                                <th scope="col" class="text-center">Nombre</th>
                                <!-- <th scope="col" class="text-center">Sucursal</th> -->
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let proveedor of data">
                                <td>{{ proveedor.rutFormato | rut }}</td>
                                <td class="cortar">
                                    {{ proveedor.nombre }}
                                    <small
                                      *ngIf="proveedor.sinDeudaCuentaCorriente && !permitirVisualizarProveedorSinDeuda"
                                      class="d-block text-warning font-weight-bold"
                                    >
                                        Sin deuda en cuenta corriente
                                    </small>
                                </td>
                                <!-- <td>{{ proveedor.direccion_completa }}</td> -->
                                <td>
                                    <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                                        (click)="selectData(proveedor)">
                                        Seleccionar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)">
                        </app-pagination>
                    </table>
                </div>
            </form>
        </div>
    </div>
</div>
